module.exports = __webpack_public_path__ + "static/media/banner.23d66ee9.jpg";